/* eslint-disable react-refresh/only-export-components */
// PageContext-Brücke zwischen Vike + React-Tree.
// Vike liefert pageContext an `+onRenderClient.tsx` und `+onRenderHtml.tsx`
// als Prop für PageShell. Damit Komponenten tief im Baum (CategoryChips,
// Page-Bodies) auf `routeParams`, `urlPathname` etc. zugreifen können,
// exponieren wir den pageContext über einen React-Context.
//
// Vike selbst bringt keinen React-Hook mit; das Pattern hier orientiert
// sich an `vike-react` und https://vike.dev/usePageContext.

import {
  createContext,
  useContext,
  type ReactNode,
} from "react";
import type { PageContext } from "vike/types";

const PageContextReact = createContext<PageContext | undefined>(undefined);

export function PageContextProvider({
  pageContext,
  children,
}: {
  pageContext: PageContext;
  children: ReactNode;
}) {
  return (
    <PageContextReact.Provider value={pageContext}>
      {children}
    </PageContextReact.Provider>
  );
}

/**
 * Liefert den aktuellen Vike-PageContext. In SSR und CSR identisch nutzbar.
 * Wirft einen Fehler, wenn der Provider fehlt — das ist Absicht, damit
 * unabsichtlich fehlende Provider-Mounts auffallen (Hot-Reload-Drift etc.).
 */
export function usePageContext(): PageContext {
  const ctx = useContext(PageContextReact);
  if (!ctx) {
    throw new Error(
      "usePageContext() außerhalb von PageContextProvider. PageShell muss den Context bereitstellen.",
    );
  }
  return ctx;
}
